/**
 * This attribute must be present on the parent element of every block
 * with its value set to the block's ID.
 * This allows blocks to apply styles to the containing element of a block.
 * For top level blocks, this attribute is set on the block root, which is
 * managed outside of React.
 * For child blocks, `SoftrPageRenderer.ChildBlock` wraps the block in a div
 * with this attribute.
 */
export const PARENT_SELECTOR_ATTRIBUTE_NAME = "data-spr-block-parent-id";
